import { DatePicker, Input } from "antd";

export const RepresentationFormAdd = () => {
  return (
    <>
      <div className="confirmation-credentials">
        <div className="confirmation-credentials-inputs-container">
          <div className="confirmation-credentials-label">
            <div className="confirmation-credentials-title">
              Наименование документа
            </div>
            <Input placeholder="Приказ" />
          </div>
          <div className="confirmation-credentials-label">
            <div className="confirmation-credentials-title">
              Номер документа
            </div>
            <Input placeholder="№ГГ-12" />
          </div>
          <div className="confirmation-credentials-label">
            <div className="confirmation-credentials-title">Дата выдачи </div>
            <DatePicker placeholder="12.12.2012" format="DD.MM.YYYY" />
          </div>
        </div>
      </div>
      <div className="organization-credentials">
        <div className="organization-credentials-label">
          <div className="organization-credentials-title">
            Организация, выдавшая документ (необ.)
          </div>
          <Input placeholder="" />
        </div>
        <div className="organization-credentials-label">
          <div className="organization-credentials-title">Описание (необ.)</div>
          <Input placeholder="" />
        </div>
      </div>
    </>
  );
};
